import { mergeRelaySets } from "applesauce-core/helpers";

const mb = 1024 * 1024;

export const CHUNK_SIZE_LARGE = 25 * mb;
export const CHUNK_SIZE_SMALL = 5 * mb;

export const SERVER_ADVERTIZEMENT_KIND = 36363;

export const DEFAULT_RELAYS = mergeRelaySets([
  "wss://relay.damus.io/",
  "wss://nos.lol/",
  "wss://relay.primal.net/",
  "wss://relay.cxplay.org"
]);

export const LOOKUP_RELAYS = mergeRelaySets(["wss://purplepag.es/"]);
